import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2060. ダッシュボード（マイタスク）
 * [GET] /workspaces/:identifier/dashboard/my_task_counts
 */
type Props = {
  identifier: string;
};

type DashboardMyTaskCounts = {
  target_year_month: number;
  payment_task_count: number;
  invoice_task_count: number;
  quotation_task_count: number;
  sales_order_contract_task_count: number;
  purchase_order_contract_task_count: number;
};

const dashboardMyTaskCounts = (props: Props): Promise<DashboardMyTaskCounts> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/my_task_counts`);
};

export const useDashboardMyTaskCounts = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'my_task_counts'],
    queryFn: () => dashboardMyTaskCounts(props),
    staleTime: 1000 * 60 * 30,
  });
};
